import * as Yup from 'yup';

// Any system object (like station or post) blueprint
export class ObjectPrototype {
	constructor(id) {
		//console.log("Create station id=", id)
		this.id = id
		this.fetch_time = undefined
		this.passport = new Map()
	}

	// Some passport key names (not all)
	static get passportKeys() {
		return Object.freeze({
			passportVersion: '_version',
			id: '_id',
			name: 'name',
			shortName: 'short_name',
			orgId: 'org_id',
			org: 'org',
			orgName: 'org_name',
			creatorId: 'creator_id',
			updateBy: 'update_by_id', // id who updates the passport
			pipelineId: 'pipeline_id',
			departmentId: 'department_id',
			department: 'department',
			sectorId: 'sector_id',
			sector: 'sector',
			metricsId: 'metrics_id',

			pipelineKm: 'pipeline_km',
			district: 'district',
			region: 'region',
			postAddress: 'post_address',
			location: 'location',
			settlement: 'settlement',
			streetHouse: 'street_house',

			relatedStations: 'related_stations',    
		
			produceDate: 'produce_date',
			brandModel: 'brand_model',
			manufacturer: 'manufacturer',
			serialNumber: 'serial_number',
			commonProtectionDevicesPresent: 'common_protection_devices_present',
			commonProtectionDevicesType: 'common_protection_devices_type',
			anodeCable: 'anode_cable',
			pipeCable: 'pipe_cable',
			anodeCroundingCableType: 'anode_crounding_cable_type',
			installationDate: 'installation_date',
			projectOrganization: 'project_organization',
			installationOrganization: 'installation_organization',
			landUser: 'land_user',
			equipmentNumber: 'equipment_number',

			referenceElectrodePresent: 'reference_electrode_present',
			referencePotentialRangeMin: 'reference_potential_range_min',
			referencePotentialRangeMax: 'reference_potential_range_max',

			notificationDistributionLists: {
				self: 'notification_distribution_lists',
				connection: 'connection',
				potentialOutOfRange: 'potential_out_of_range',
			},
			
			notes: 'notes',
			isActive: "is_active",
		})
	}

	static get settingNames() {
		return Object.freeze({
			[ObjectPrototype.passportKeys.name]: 'Повна назва',
			[ObjectPrototype.passportKeys.shortName]: 'Коротка назва',
			[ObjectPrototype.passportKeys.pipelineId]: 'Найменування Газопроводу/Нафтопроводу, КС, ПСГ',
			[ObjectPrototype.passportKeys.departmentId]: 'Адміністративна ланка 2-го рівня',
			[ObjectPrototype.passportKeys.sectorId]: 'Адміністративна ланка 3-го рівня',
			[ObjectPrototype.passportKeys.orgId]: 'Експлуатуюча організація',
			[ObjectPrototype.passportKeys.district]: 'Район',
			[ObjectPrototype.passportKeys.region]: 'Регіон',
			[ObjectPrototype.passportKeys.postAddress]: 'Адреса',
			[ObjectPrototype.passportKeys.location]: 'Координати місцезнаходження (довгота, широта)',
			[ObjectPrototype.passportKeys.settlement]: 'Населенний пункт',
			[ObjectPrototype.passportKeys.streetHouse]: 'Вулиця, № будинку',
			[ObjectPrototype.passportKeys.pipelineKm]: 'Місце розташування(км)',
			[ObjectPrototype.passportKeys.relatedStations]: 'Пов\'язані станції',
			[ObjectPrototype.passportKeys.produceDate]: 'Дата випуску',
			[ObjectPrototype.passportKeys.brandModel]: 'Марка/Модель',
			[ObjectPrototype.passportKeys.manufacturer]: 'Виробник',
			[ObjectPrototype.passportKeys.serialNumber]: 'Серійний номер',
			[ObjectPrototype.passportKeys.commonProtectionDevicesPresent]: 'Наявність пристроїв спільного захисту',
			[ObjectPrototype.passportKeys.commonProtectionDevicesType]: 'Тип пристроїв спільного захисту',
			[ObjectPrototype.passportKeys.anodeCable]: 'Кабель анодного заземлеення тип, переріз',
			[ObjectPrototype.passportKeys.pipeCable]: 'Кабель до газопроводу/нафтопроводу, тип, переріз',
			[ObjectPrototype.passportKeys.anodeCroundingCableType]: 'Тип анодного зазелювача',
			[ObjectPrototype.passportKeys.installationDate]: 'Дата монтажу',
			[ObjectPrototype.passportKeys.projectOrganization]: 'Проектна організація',
			[ObjectPrototype.passportKeys.installationOrganization]: 'Будівельно-монтажна організація',
			[ObjectPrototype.passportKeys.landUser]: 'Землекористувач',
			[ObjectPrototype.passportKeys.equipmentNumber]: 'Інвентарний номер',
			[ObjectPrototype.passportKeys.referenceElectrodePresent]: 'Наявність електроду порівняння',
			[ObjectPrototype.passportKeys.referencePotentialRangeMin]: 'Мінімальний потенціал',
			[ObjectPrototype.passportKeys.referencePotentialRangeMax]: 'Максимальний потенціал',
			[ObjectPrototype.passportKeys.notificationDistributionLists.self]: Object.freeze({
				self: 'Сповіщення',
				[ObjectPrototype.passportKeys.notificationDistributionLists.connection]: 'Сповіщати про втрату зв\'язку',
				[ObjectPrototype.passportKeys.notificationDistributionLists.potentialOutOfRange]: 'Потенціал поза цільовим діапазоном',
			}),
			[ObjectPrototype.passportKeys.notes]: 'Примітки',
		})
	}

	static get departmentDefaultTitle() {
		return 'Адміністративна ланка 2-го рівня'
	}

	static get sectorIdDefaultTitle() {
		return 'Адміністративна ланка 3-го рівня'
	}

	setLocation(lat, lng) {
		this.passport.set(
			ObjectPrototype.passportKeys.location,
			{
				"type": "Point",
				"coordinates": [lng, lat]
			}
		)
	}

	// Returns one metric by key
	// metricName: key
	// unit: (optional) from which unit reads the metric
	getMetric(metricName, unit="any") {
		console.error("Need to define \"getMetric(metricName, unit=\"any\")\" method", metricName, unit)
		return undefined
	}

	get name() {
		if (this.passport.get(ObjectPrototype.passportKeys.name) !== undefined) {
			return this.passport.get(ObjectPrototype.passportKeys.name)
		}

		return "-"
	}

	get shortName() {
		return this.passport.get(ObjectPrototype.passportKeys.shortName)
	}

	get isActive() {
		return this.passport.has(ObjectPrototype.passportKeys.isActive) && this.passport.get(ObjectPrototype.passportKeys.isActive)
	}

	get updateTime() {
		// Returns update time
		let time = undefined

		return time
	}

	get updateTimeText() {
		// Returns update time as text string
		let time = this.updateTime

		if (time === undefined) {
			return "-"
		} else {
			return time.toLocaleString()
		}
	}

	get measureTime() {
		return undefined
	}

	get measureTimeText() {
		// Returns update time as text string
		const time = this.measureTime
		
		if (time === undefined) {
			return "-"
		} else {
			return time.toLocaleString()
		}
	}

	static flagText(value, reverse=false) {
		let metric = value

		if (value === undefined || value === '' || typeof value !== 'boolean') {
			return "не відстежується"
		}
		
		if (reverse) {
			metric = !metric
		}
		
		if (metric) {
			return "так"
		} else {
			return "ні"
		}
	}
}




export class Metric {
	// Station metric object
	constructor(
		id = undefined,
		value = undefined,
		time = undefined,
		meta=new Map()
	) {
		this.id = id
		this.value = value
		this.time = time
		this.meta = meta
	}
}




const requiredPromt = 'Обов\'язкове поле'
const overMinLenPromt = 'Довжина меньше мінімальної'
const overMaxLenPromt = 'Довжина більше максимальної'
const onlyIntegersPromt = 'Має бути цілим числом'
const onlyPositivePromt = 'Має бути натуральним числом'
const wrongInputPromt = 'Не відповідає вимогам'
export const nameRegex = /^[0-9а-яА-ЯґҐєЄіІїЇIVX "«».,'()№!/\-///—/]*$/
export const PassportSchema = Yup.object().shape({
	name: Yup.string()
		.typeError(wrongInputPromt)
		.required(requiredPromt)
		.min(4, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(60, overMaxLenPromt)
		.matches(nameRegex, wrongInputPromt),
	short_name: Yup.string()
		.typeError(wrongInputPromt)
		.notRequired()
		.nullable()
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : undefined)) // if empty string
		.max(24, overMaxLenPromt)
		.matches(nameRegex, wrongInputPromt),
	org_id: Yup.string()
		.typeError(wrongInputPromt)
		.required(requiredPromt),
	department_id: Yup.string()
		.nullable(true)
		.typeError(wrongInputPromt),
		//.required(requiredPromt),
	sector_id: Yup.string()
		.nullable(true)
		.typeError(wrongInputPromt),
		//.required(requiredPromt),
	pipeline_id: Yup.string()
		.nullable(true)
		.typeError(wrongInputPromt),
		//.required(requiredPromt),
	pipeline_km: Yup.string()
		.typeError(wrongInputPromt)
		.min(0, overMinLenPromt)
		.max(20, overMaxLenPromt),
	district: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	region: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	post_address: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(100, overMaxLenPromt),
	// location: Yup.object({
	// 	type: Yup.string(),
	// 		//.required(requiredPromt),
	// 	coordinates: Yup.array().of(Yup.number()),
	// 		//.required(requiredPromt),
	// }),
	settlement: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	street_house: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	brand_model: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	manufacturer: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	serial_number: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	produce_date: Yup.date()
		.nullable()
		.default(undefined)
		.typeError(wrongInputPromt)
		.min(new Date(1900, 0, 1)),
	equipment_number: Yup.number()
		.typeError(wrongInputPromt)
		.integer(onlyIntegersPromt)
		.positive(onlyPositivePromt),
	installation_date: Yup.date()
		.nullable()
		.default(undefined)
		.typeError(wrongInputPromt)
		.min(new Date(1900, 0, 1)),
	reference_electrode_present: Yup.boolean(),
	common_protection_devices_present: Yup.boolean(),
	common_protection_devices_type: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	project_organization: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	installation_organization: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(60, overMaxLenPromt),
	land_user: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(60, overMaxLenPromt),
	anode_cable: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	pipe_cable: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	anode_crounding_cable_type: Yup.string()
		.typeError(wrongInputPromt)
		.min(1, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(20, overMaxLenPromt),
	related_stations: Yup.array().of(
		Yup.string()
	),
	is_active: Yup.boolean()
		.required()
		.default(true),
	notes: Yup.string()
		.typeError(wrongInputPromt)
		.min(0, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(200, overMaxLenPromt),
});


export const SettingsSchema = Yup.object().shape({
	ip: Yup.string()
		.typeError(wrongInputPromt)
		.required(requiredPromt)
		.min(7, overMinLenPromt)
		.transform((value) => (value ? value : null)) // if empty string
		.max(15, overMaxLenPromt)
		.matches(/(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/,
			'Може містити тільки IPv4 адресу')
		.notOneOf(['127.0.0.1'], 'Адреса 127.0.0.1 заборонена'),
	[ObjectPrototype.passportKeys.referencePotentialRangeMin]: Yup.lazy(
		(value) => (
			value === '' ?
			Yup.string() :
			Yup.number()
				.min(-5, overMinLenPromt)
				.max(5, overMaxLenPromt)
				.typeError(wrongInputPromt)
	)),
	[ObjectPrototype.passportKeys.referencePotentialRangeMax]: Yup.lazy(
		(value) => (
			value === '' ?
			Yup.string() :
			Yup.number()
				.min(-5, overMinLenPromt)
				.max(5, overMaxLenPromt)
				.moreThan(Yup.ref(ObjectPrototype.passportKeys.referencePotentialRangeMin), overMinLenPromt)
				.typeError(wrongInputPromt)
	)),
	notification_distribution_lists: Yup.object().shape({
		connection: Yup.boolean()
			.default(false),
		u220: Yup.boolean()
			.default(false),
		channel_1: Yup.boolean()
			.default(false),
		channel_2: Yup.boolean()
			.default(false),
		shunt: Yup.boolean()
			.default(false),
		security_circuit_1: Yup.boolean()
			.default(false),
		security_circuit_2: Yup.boolean()
			.default(false),
		security_circuit_3: Yup.boolean()
			.default(false),
		security_circuit_4: Yup.boolean()
			.default(false),
		security_circuit_5: Yup.boolean()
			.default(false),
		security_circuit_6: Yup.boolean()
			.default(false),
		potential_out_of_range: Yup.boolean()
			.default(false),
	}),
})
